<template>
    
    <b-container fluid class="p-0">
        <b-row>
            <b-col cols="4">

                <label> {{ $t('replacementRules.searchOriginal') }}</label>
                <fg-input
                    type="search"
                    :placeholder="$t('replacementRules.originalText')"
                    addon-left-icon="fa fa-filter" @input="debounceSearch" v-model="searchFilter"/>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-table
                striped
                hover
                :selectable="true"
                select-mode="single"
                :items="ruleItems"
                :fields="ruleFields"
                :tbody-tr-class="ruleClass"
                class="rule"
                :per-page="rulePerPage"
                :current-page="ruleCurrentPage"
                :filter="debounceFilter"
                :filter-included-fields="['originalText']"
                @row-selected="onRuleRowSelected"
                @filtered="rulesFiltered"
                >
                </b-table>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <TablePagination :total-rows="ruleTotalRows" :per-page="rulePerPage" @pageChange="onPageChange"/>
                
            </b-col>
        </b-row>
    </b-container>
    
</template>

<script>
import { debounce } from '@/util/debounce';

const RuleTypes = { RULE:'rule' , EXAMPLE:'example'}


export default {
    name: 'ReplacementRuleTable',
    props: {
        configurationId: { default: null },
        ruleType: { default: null }
    },
    data:function() {
        return {
            ruleFields: [
                { key: "originalText" , label:this.$t('replacementRules.originalText') },
                { key: "shortText" , label: this.$t('replacementRules.shortText')},
                { key: "longText", label: this.$t('replacementRules.longText')}
            ],
            rulePerPage:10,
            ruleCurrentPage:1,
            ruleTotalRows:0,
            ruleItems: [],
            searchFilter: null,
            debounceFilter: null
        }
    },
    created() {
        this.debounceSearch = debounce( newFilter => {
            this.debounceFilter = newFilter
        }, 500 )
    },
    methods: {
        initialize() {
            this.loadRules()
            this.debounceFilter = null
            this.searchFilter = null
        },
        ruleClass( item, type ) {
            if( !item || type != 'row') return
            if( item.uiType === 'rule' ) return 'rule'
            if( item.uiType === 'example') return 'example'
        },
        loadRules() {
            this.$store.dispatch('replacementRules/loadRules' , { configurationId: this.configurationId , ruleType:this.ruleType })
        },
        onRuleRowSelected(item) {
            if( item.length > 0 )
                this.$emit('ruleSelected' , item[0] )
        },
        updateItems() {
            const items = []
            
            for( let rule of this.replacementRules ) {
                const ruleItem = { ...rule }
                ruleItem.uiType = RuleTypes.RULE
                items.push( ruleItem )
            }
            const ret = []
            for( const item of items ) {
                ret.push(item)
            }
            const exampleItems = this.ruleExamples
            for( const example of exampleItems ) {
                if( !items.find( element => element.originalText == example)) {
                    ret.push( {
                        originalText: example,
                        uiType: RuleTypes.EXAMPLE
                    })
                }
            }
            
            this.ruleItems = ret
            
        },
        onPageChange(newPage) {
            this.ruleCurrentPage = newPage
        },
        rulesFiltered(data) {
            //console.log(data)
            this.ruleTotalRows = data.length
            this.ruleCurrentPage = 1
        }
    },
    watch: {
        configurationId() {
            this.initialize()
        },
        ruleType(newType) {
            this.initialize()
            this.$store.dispatch('replacementRules/loadRuleExamples' , { ruleType: newType } )
        },
        replacementRules() {
            this.updateItems()
        },
        ruleExamples() {
            this.updateItems()
        },
        ruleItems(items) {
            this.ruleTotalRows = items.length
            this.ruleCurrentPage = 1
        }
    },
    computed: {
        replacementRules() {
            return this.$store.getters['replacementRules/getReplacementRules'](this.configurationId,this.ruleType) 
        },
        ruleExamples() {
            return this.$store.getters['replacementRules/getRuleExamples'](this.ruleType)
        }
    },
    beforeCreate() {
        const replacementRules = () => import('@/store/realtime/replacementRules')
        if( !this.$store.state.replacementRules ) {
            this.$store.registerModule("replacementRules" , replacementRules )
        }
    },
    mounted() {
        this.loadRules()
        this.$store.dispatch('replacementRules/loadRuleExamples' , { ruleType: this.ruleType } )
    }
};
</script>

<style scoped lang="css">

.noPadding {
    padding:0
}
</style>